export const getApprobalListByParam = (
  approverEmployees = [],
  referenceEmployees = []
) => {

  // TODO 결제 순서 적용 필요.
  return [
    ...approverEmployees.map((a, idx) => ({
      approverEmpIdx: a.idx,
      type: "approver",
      // order: idx + 1
      order: 1
    })),
    ...referenceEmployees.map((a, idx) => ({
      approverEmpIdx: a.idx,
      type: "reference",
      // order: approverEmployees.length + idx + 1
      order: 1
    }))
  ]
}